<template>
  <footer class="footer tw-bg-[var(--c-primary)] tw-py-10 tw-text-white">
    <div class="container tw-mx-auto tw-px-4">
      <div class="tw-mb-12 tw-grid tw-grid-cols-1 tw-gap-8 lg:tw-grid-cols-12">
        <!-- LOGO ve İletişim Bloğu -->
        <div class="tw-order-1 tw-flex tw-flex-col tw-items-center lg:tw-order-2 lg:tw-col-span-8">
          <!-- Logo -->
          <NuxtImg :src="logo" alt="Cope&Co. Estate Agents" class="tw-mb-8 tw-w-56" />
          <!-- Telefon -->
          <h2 class="tw-mb-8 tw-text-2xl tw-font-medium tw-text-[var(--c-secondary)]">
            {{ vars.companyPhoneText }}
          </h2>
          <div class="tw-mb-8 tw-flex tw-gap-3">
            <nuxt-link
              v-if="vars.facebookUrl"
              :external="true"
              :to="vars.facebookUrl"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-white hover:tw-bg-[var(--c-secondary)]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.33317 9.00016H10.9998L11.6665 6.3335H9.33317V5.00016C9.33317 4.3135 9.33317 3.66683 10.6665 3.66683H11.6665V1.42683C11.4492 1.39816 10.6285 1.3335 9.76184 1.3335C7.95184 1.3335 6.6665 2.43816 6.6665 4.46683V6.3335H4.6665V9.00016H6.6665V14.6668H9.33317V9.00016Z"
                  fill="var(--c-primary)"
                />
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.linkedinUrl"
              :external="true"
              :to="vars.linkedinUrl"
              target="_blank"
              class="n-link tw-group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-white hover:tw-bg-[var(--c-secondary)]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.62663 3.33351C4.62645 3.68713 4.48581 4.0262 4.23563 4.27613C3.98546 4.52605 3.64625 4.66636 3.29263 4.66618C2.93901 4.666 2.59994 4.52536 2.35001 4.27518C2.10009 4.02501 1.95978 3.6858 1.95996 3.33218C1.96014 2.97856 2.10078 2.63949 2.35096 2.38956C2.60113 2.13964 2.94034 1.99934 3.29396 1.99951C3.64758 1.99969 3.98665 2.14033 4.23658 2.39051C4.4865 2.64068 4.6268 2.97989 4.62663 3.33351ZM4.66663 5.65351H1.99996V14.0002H4.66663V5.65351ZM8.87996 5.65351H6.22663V14.0002H8.85329V9.62018C8.85329 7.18018 12.0333 6.95351 12.0333 9.62018V14.0002H14.6666V8.71351C14.6666 4.60018 9.95996 4.75351 8.85329 6.77351L8.87996 5.65351Z"
                  fill="var(--c-primary)"
                />
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.instagramUrl"
              :external="true"
              :to="vars.instagramUrl"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-white hover:tw-bg-[var(--c-secondary)]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.20016 1.3335H10.8002C12.9335 1.3335 14.6668 3.06683 14.6668 5.20016V10.8002C14.6668 11.8257 14.2594 12.8092 13.5343 13.5343C12.8092 14.2594 11.8257 14.6668 10.8002 14.6668H5.20016C3.06683 14.6668 1.3335 12.9335 1.3335 10.8002V5.20016C1.3335 4.17466 1.74088 3.19116 2.46602 2.46602C3.19116 1.74088 4.17466 1.3335 5.20016 1.3335ZM5.06683 2.66683C4.43031 2.66683 3.81986 2.91969 3.36977 3.36977C2.91969 3.81986 2.66683 4.43031 2.66683 5.06683V10.9335C2.66683 12.2602 3.74016 13.3335 5.06683 13.3335H10.9335C11.57 13.3335 12.1805 13.0806 12.6306 12.6306C13.0806 12.1805 13.3335 11.57 13.3335 10.9335V5.06683C13.3335 3.74016 12.2602 2.66683 10.9335 2.66683H5.06683ZM11.5002 3.66683C11.7212 3.66683 11.9331 3.75463 12.0894 3.91091C12.2457 4.06719 12.3335 4.27915 12.3335 4.50016C12.3335 4.72118 12.2457 4.93314 12.0894 5.08942C11.9331 5.2457 11.7212 5.3335 11.5002 5.3335C11.2791 5.3335 11.0672 5.2457 10.9109 5.08942C10.7546 4.93314 10.6668 4.72118 10.6668 4.50016C10.6668 4.27915 10.7546 4.06719 10.9109 3.91091C11.0672 3.75463 11.2791 3.66683 11.5002 3.66683ZM8.00016 4.66683C8.88422 4.66683 9.73206 5.01802 10.3572 5.64314C10.9823 6.26826 11.3335 7.11611 11.3335 8.00016C11.3335 8.88422 10.9823 9.73206 10.3572 10.3572C9.73206 10.9823 8.88422 11.3335 8.00016 11.3335C7.11611 11.3335 6.26826 10.9823 5.64314 10.3572C5.01802 9.73206 4.66683 8.88422 4.66683 8.00016C4.66683 7.11611 5.01802 6.26826 5.64314 5.64314C6.26826 5.01802 7.11611 4.66683 8.00016 4.66683ZM8.00016 6.00016C7.46973 6.00016 6.96102 6.21088 6.58595 6.58595C6.21088 6.96102 6.00016 7.46973 6.00016 8.00016C6.00016 8.5306 6.21088 9.0393 6.58595 9.41438C6.96102 9.78945 7.46973 10.0002 8.00016 10.0002C8.5306 10.0002 9.0393 9.78945 9.41438 9.41438C9.78945 9.0393 10.0002 8.5306 10.0002 8.00016C10.0002 7.46973 9.78945 6.96102 9.41438 6.58595C9.0393 6.21088 8.5306 6.00016 8.00016 6.00016Z"
                  fill="var(--c-primary)"
                />
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.youtubeUrl"
              :external="true"
              :to="vars.youtubeUrl"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-white hover:tw-bg-[var(--c-secondary)]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_23_2087)">
                  <path
                    d="M8.00016 2.6665C8.57016 2.6665 9.15483 2.68117 9.7215 2.70517L10.3908 2.73717L11.0315 2.77517L11.6315 2.81584L12.1795 2.8585C12.7742 2.90402 13.3338 3.1578 13.7598 3.5752C14.1859 3.99259 14.4511 4.54686 14.5088 5.1405L14.5355 5.42384L14.5855 6.0305C14.6322 6.65917 14.6668 7.3445 14.6668 7.99984C14.6668 8.65517 14.6322 9.3405 14.5855 9.96917L14.5355 10.5758C14.5268 10.6732 14.5182 10.7672 14.5088 10.8592C14.4511 11.4529 14.1858 12.0073 13.7596 12.4247C13.3334 12.8421 12.7736 13.0958 12.1788 13.1412L11.6322 13.1832L11.0322 13.2245L10.3908 13.2625L9.7215 13.2945C9.14805 13.3194 8.57415 13.3323 8.00016 13.3332C7.42618 13.3323 6.85227 13.3194 6.27883 13.2945L5.6095 13.2625L4.96883 13.2245L4.36883 13.1832L3.82083 13.1412C3.22613 13.0957 2.66653 12.8419 2.24048 12.4245C1.81443 12.0071 1.54921 11.4528 1.4915 10.8592L1.46483 10.5758L1.41483 9.96917C1.36385 9.31393 1.33673 8.65705 1.3335 7.99984C1.3335 7.3445 1.36816 6.65917 1.41483 6.0305L1.46483 5.42384C1.4735 5.3265 1.48216 5.2325 1.4915 5.1405C1.54919 4.54697 1.81431 3.99278 2.24022 3.5754C2.66614 3.15802 3.22558 2.90417 3.82016 2.8585L4.3675 2.81584L4.9675 2.77517L5.60883 2.73717L6.27816 2.70517C6.85183 2.68026 7.42596 2.66737 8.00016 2.6665ZM8.00016 3.99984C7.45016 3.99984 6.88416 4.0145 6.3335 4.03717L5.6815 4.0685L5.0555 4.10517L4.4675 4.14517L3.92883 4.18717C3.64572 4.20726 3.37886 4.32693 3.17556 4.52499C2.97226 4.72304 2.84564 4.98668 2.81816 5.26917C2.74016 6.07517 2.66683 7.0785 2.66683 7.99984C2.66683 8.92117 2.74016 9.9245 2.81816 10.7305C2.87483 11.3118 3.33616 11.7638 3.92883 11.8125L4.4675 11.8538L5.0555 11.8938L5.6815 11.9312L6.3335 11.9625C6.88416 11.9852 7.45016 11.9998 8.00016 11.9998C8.55016 11.9998 9.11616 11.9852 9.66683 11.9625L10.3188 11.9312L10.9448 11.8945L11.5328 11.8545L12.0715 11.8125C12.3546 11.7924 12.6215 11.6727 12.8248 11.4747C13.0281 11.2766 13.1547 11.013 13.1822 10.7305C13.2602 9.9245 13.3335 8.92117 13.3335 7.99984C13.3335 7.0785 13.2602 6.07517 13.1822 5.26917C13.1547 4.98668 13.0281 4.72304 12.8248 4.52499C12.6215 4.32693 12.3546 4.20726 12.0715 4.18717L11.5328 4.14584L10.9448 4.10584L10.3188 4.0685L9.66683 4.03717C9.11159 4.01328 8.55592 4.00083 8.00016 3.99984ZM6.66683 6.38317C6.66679 6.31801 6.68266 6.25383 6.71307 6.19621C6.74349 6.13858 6.78751 6.08926 6.84133 6.05253C6.89515 6.01579 6.95712 5.99277 7.02187 5.98544C7.08661 5.97812 7.15217 5.98672 7.21283 6.0105L7.26683 6.03717L10.0668 7.65317C10.1226 7.68534 10.1698 7.73049 10.2043 7.78479C10.2389 7.83909 10.2599 7.90094 10.2654 7.96507C10.271 8.0292 10.261 8.09373 10.2363 8.15317C10.2116 8.21261 10.1729 8.26521 10.1235 8.3065L10.0668 8.3465L7.26683 9.96317C7.2104 9.99584 7.14685 10.0142 7.08169 10.0167C7.01654 10.0192 6.95176 10.0058 6.893 9.97749C6.83424 9.94923 6.78328 9.90703 6.74456 9.85457C6.70584 9.80211 6.68053 9.74098 6.67083 9.6765L6.66683 9.6165V6.38317Z"
                    fill="var(--c-primary)"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_23_2087">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </nuxt-link>
            <nuxt-link
              v-if="vars.tiktokUrl"
              :external="true"
              :to="vars.tiktokUrl"
              target="_blank"
              class="n-link group tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center !tw-rounded-full tw-border-[1px] tw-bg-white hover:tw-bg-[var(--c-secondary)]"
              style="border-color: var(--c-tertiary)"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.0668 3.88C10.6111 3.35975 10.3599 2.69162 10.3601 2H8.3001V10.2667C8.28422 10.714 8.09535 11.1377 7.77328 11.4486C7.45121 11.7595 7.02107 11.9333 6.57344 11.9333C5.62677 11.9333 4.8401 11.16 4.8401 10.2C4.8401 9.05333 5.94677 8.19333 7.08677 8.54667V6.44C4.78677 6.13333 2.77344 7.92 2.77344 10.2C2.77344 12.42 4.61344 14 6.56677 14C8.6601 14 10.3601 12.3 10.3601 10.2V6.00667C11.1954 6.60657 12.1983 6.92843 13.2268 6.92667V4.86667C13.2268 4.86667 11.9734 4.92667 11.0668 3.88Z"
                  fill="var(--c-primary)"
                />
              </svg>
            </nuxt-link>
          </div>

          <!-- Mail -->
          <p class="tw-mb-6">
            <a
              href="mailto:contact@copeandco.co.uk"
              class="tw-text-white hover:tw-cursor-pointer hover:tw-text-[var(--c-secondary)]"
            >
              contact@copeandco.co.uk
            </a>
          </p>

          <!-- Contact Us -->
          <p class="tw-mb-6">
            <nuxt-link to="/contact-us" :external="true" class="!tw-text-white hover:tw-text-[var(--c-secondary)]">
              CONTACT US
            </nuxt-link>
          </p>

          <!-- Register to Property Alerts -->
          <p class="tw-mb-10">
            <nuxt-link
              to="/property-alerts"
              :external="true"
              class="tw-text-[var(--c-text-tertiary)] tw-text-white hover:tw-text-[var(--c-secondary)]"
            >
              REGISTER TO PROPERTY ALERTS
            </nuxt-link>
          </p>

          <!-- Örnek bloklar -->
          <div class="tw-mb-6 tw-flex tw-flex-wrap tw-justify-center tw-gap-2">
            <div v-for="(card, index) in cards" :key="index" class="tw-h-12 tw-w-32 tw-overflow-hidden tw-bg-gray-200">
              <img :src="card.photo" class="tw-h-full tw-w-full tw-object-cover" />
            </div>
          </div>
        </div>

        <!-- Menü Bloğu -->
        <div class="tw-order-2 lg:tw-order-1 lg:tw-col-span-2">
          <div class="tw-space-y-4">
            <div
              v-for="(menuItem, itemIndex) in footerMenuItems"
              :key="`footerMenuItem-${itemIndex}`"
              class="footer-menu-item"
            >
              <!-- Ana menü linki ya da sub-menu toggle -->
              <a
                href="javascript:void(0)"
                @click="menuItem.has_sub_menu ? toggleSubMenu(itemIndex) : handleMenuLinkClick(menuItem)"
                :aria-expanded="openSubMenu === itemIndex"
                class="n-link tw-flex tw-cursor-pointer tw-items-center tw-text-sm tw-text-[var(--c-text-tertiary)] hover:tw-text-[var(--c-secondary)]"
              >
                <h5>{{ menuItem.name.toUpperCase() }}</h5>
                <span>
                  <svg
                    v-if="menuItem.has_sub_menu"
                    width="10"
                    height="10"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="tw-ml-4 tw-fill-current"
                  >
                    <path d="M14 8.49799H8V14.498H6V8.49799H0V6.49799H6V0.497986H8V6.49799H14V8.49799Z" />
                  </svg>
                </span>
              </a>
              <!-- Alt menü -->
              <div
                v-if="menuItem.has_sub_menu"
                class="footer-submenu tw-mt-1 tw-space-y-1"
                :class="{ 'is-active': openSubMenu === itemIndex }"
                role="region"
                :aria-hidden="openSubMenu !== itemIndex"
              >
                <div
                  v-for="(subMenu, sIndex) in menuItem.sub_menus"
                  :key="`footerSubMenu-${itemIndex}-${sIndex}`"
                  class="footer-submenu-item"
                >
                  <nuxt-link
                    :to="subMenu.url || '/'"
                    :target="subMenu.is_open_new_tab ? '_blank' : '_self'"
                    :external="true"
                    class="n-link tw-text-[var(--c-text-secondary)] hover:tw-text-[var(--c-secondary)]"
                  >
                    <h6>{{ subMenu.name }}</h6>
                  </nuxt-link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Bilgilendirme/Künye Bloğu -->
        <div class="info tw-order-3 tw-space-y-2 lg:tw-order-3 lg:tw-col-span-2">
          <p>{{ vars.companyTradingAsText }}, Trading As:</p>
          <p>{{ company.name }}</p>
          <p>Company Number: {{ vars.companyNumberText }}</p>
          <p>Registered Address: {{ vars.companyAddressText }}</p>
          <p>
            Redress Scheme:
            {{ vars.companyRedressSchemeText }}
          </p>
          <p>
            <a :href="vars.companyRedressSchemeLinkUrl" class="n-link tw-break-words" target="_blank" rel="noreferrer">
              {{ vars.companyRedressSchemeLinkUrl }}
            </a>
          </p>

          <div>
            <a
              v-for="(logo, index) in redress"
              :key="`redressLogos-${index}`"
              data-w-id="103b4bea-4a5e-266e-2bf1-8a17dc59e547"
            >
              <img style="max-height: 42px" :title="logo.title" :alt="logo.title" :src="logo.photo" />
            </a>
          </div>
        </div>
      </div>

      <!-- En aşağıdaki içerikler -->
      <div
        class="tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-y-3 tw-pt-4 tw-text-xs md:tw-flex-row md:tw-gap-x-4 lg:tw-gap-x-0"
      >
        <span class="tw-text-center">
          © {{ new Date().getFullYear() }} Cope&Co. Estate Agents. All rights reserved.
        </span>
        <span class="tw-text-center lg:tw-mr-[150px]">
          Powered by
          <a href="https://www.iceberg-digital.co.uk/neuron/home" target="_blank" class="n-link"> <b>Neuron</b></a>
          |
          <a href="https://www.iceberg-digital.co.uk/" target="_blank" class="n-link"><b>Iceberg Digital</b></a>
        </span>
        <span>
          <nuxt-link
            to="/privacy-policy"
            :external="true"
            class="n-link tw-text-[var(--c-text-tertiary)] hover:tw-text-[var(--c-secondary)]"
          >
            Privacy Policy
          </nuxt-link>
        </span>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineNuxtComponent, navigateTo } from '#app';
import { mapState } from 'pinia';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useWebsiteStore } from '~/units/website/store';

interface MenuItem {
  name: string;
  url: string;
  has_sub_menu: boolean;
  is_open_new_tab: boolean;
  sub_menus?: MenuItem[];
}

export default defineNuxtComponent({
  name: 'CopeAndCoFooter',
  mixins: [ComponentMixin],

  data() {
    return {
      menuVisible: false,
      isScrolled: false,
      openSubMenu: null as number | null,
    };
  },

  computed: {
    redress() {
      return this.groupedVariables.redress;
    },
    cards() {
      return this.groupedVariables.cards;
    },
    ...mapState(useWebsiteStore, ['company', 'headerMenuItems']),

    logo(): string {
      const currentCompany = this.company as any;
      const defaultLogo = currentCompany?.logo || '';
      // Hiçbir koşul olmaksızın sadece default logo dönsün.
      return defaultLogo;
    },

    footerMenuItems(): MenuItem[] {
      // headerMenuItems'ı footer için kullanıyorsan burayı düzenleyebilirsin
      return (this.headerMenuItems as MenuItem[]) || [];
    },
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll(): void {
      this.isScrolled = window.scrollY > 50;
    },

    toggleSubMenu(index: number): void {
      // Açık olan alt menüyü tekrar tıklarsan kapatır, değilse açar
      this.openSubMenu = this.openSubMenu === index ? null : index;
    },

    handleMenuLinkClick(menuItem: MenuItem): void {
      if (!menuItem || menuItem.has_sub_menu || !menuItem.url) return;
      navigateTo(menuItem.url, {
        external: !!menuItem.is_open_new_tab,
        open: { target: menuItem.is_open_new_tab ? '_blank' : '_self' },
      });
    },
  },
});
</script>

<style scoped>
.info p {
  font-family: var(--f-primary), sans-serif !important;
  font-weight: 300 !important;
  line-height: 160% !important;
  color: var(--c-text-tertiary) !important;
}
.info a:hover {
  color: var(--c-secondary) !important;
}
a:hover {
  color: var(--c-secondary) !important;
}

.footer {
  font-family:
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    sans-serif;
}

/* Submenu ilk etapta görünmesin */
.footer-submenu {
  display: none;
}

/* openSubMenu eşleştiğinde 'is-active' class'ı ile görünür */
.footer-submenu.is-active {
  display: block;
}

.footer-menu-item a {
  display: inline-flex;
  align-items: center;
}

.footer-submenu-item a {
  display: block;
}
</style>
